import { Outlet } from 'react-router';
import { Header } from '../../molecules';
import { Chat } from '../chat/chat-panel';
import { useStore } from '@/store';

export const AppLayout = () => {
  const userId = useStore(({ config: c }) => c.userId);
  return (
    <>
      {userId ? <Header /> : null}
      <Outlet />
      {userId ? <Chat /> : null}
    </>
  );
};

export default AppLayout;
